export enum EOperationType {
  Protocol = 'protocol',
  Registry = 'registry',
  Enrichment = 'enrichment',
}

export interface IDwhDataPreparationForm {
  operationType: EOperationType;
  taxCode: string | null;
  taxPeriod: string | null;
  kndCode: string | null;
  reportingYear: number | null;
  corrNum: string | null;
}

